export default __webpack_public_path__ + "static/media/patent-bottom-image-mobile.png";